import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ITipoDispositivo,
  ICreateTipoDispositivo,
  IListado,
  IQueryParam,
  IUpdateTipoDispositivo,
} from 'modelos/src';
import { HttpService } from '../../../auxiliares/http.service';
import { HelperService } from '../../../auxiliares/helper.service';
import { apiBase } from '../../../../environments/environment';

const api = apiBase;

@Injectable({
  providedIn: 'root',
})
export class TipoDispositivosService {
  constructor(private http: HttpService) {}

  public listar(
    queryParams?: IQueryParam
  ): Observable<IListado<ITipoDispositivo>> {
    let params = HelperService.getQueryParams(queryParams);
    return this.http.get(`${api}/tipodispositivos`, { params });
  }

  public crear(dato: ICreateTipoDispositivo): Observable<ITipoDispositivo> {
    return this.http.post(`${api}/tipodispositivos`, dato);
  }

  public listarPorId(id: string): Observable<ITipoDispositivo> {
    return this.http.get(`${api}/tipodispositivos/${id}`);
  }

  public listarPorNombre(nombre: string): Observable<ITipoDispositivo> {
    return this.http.get(`${api}/tipodispositivos/nombre/${nombre}`);
  }

  public editar(
    id: string,
    dato: IUpdateTipoDispositivo
  ): Observable<ITipoDispositivo> {
    return this.http.put(`${api}/tipodispositivos/${id}`, dato);
  }

  public eliminar(id: string): Observable<void> {
    return this.http.delete(`${api}/tipodispositivos/${id}`);
  }
}
